<template>
  <TrfModal
    :titulo=titulo
    idModal="modal-cadastro-edicao-grupo-tarefas"
    :isBtnLoading="loading.btnSalvar"
    :btnSaveName="isModalEdicao ? 'Salvar' : 'Cadastrar'"
    @save="isModalEdicao ? _editarGrupoDeTarefas() : chamarCadastroGrupo()"
    :isBtnOkDisabled="loading.campoEmpresas"
  >
    <div>
      <ul class="modal-tabs has-text-weight-bold">
        <li>
          <a id="tab-cadastro-grupo"
             :class="{
              'is-active': tabSelecionada == 'cadastro' || tabSelecionada == '',
              }"
             @click="abrirTabCadastro"
            ><span>&nbsp;Cadastro</span>
          </a>
        </li>
        <li v-if="!isGrupoPadraoProps">
          <a id="tab-vinculo-empresas"
            :class="{ 'is-active': tabSelecionada == 'vinculo-empresas'}"
            @click="abrirTabEmpresas"
          >
            <span>&nbsp; Vínculo de empresas</span>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="loading.conteudo">
        <span class="button is-large is-fullwidth is-loading"></span>
    </div>
    <form v-else>
      <div v-show="tabSelecionada == 'cadastro' || tabSelecionada == ''">
        <TrfInput
          label="Nome"
          placeholder="Nome do grupo"
          id="nome-grupo"
          maxLength="100"
          v-model="this.grupoDeTarefas.nome"
          ref="inputNome"
          :isDisabled="isGrupoPadraoProps"
          :tipLabel="isGrupoPadraoProps ? 'Grupos padrões não podem ter o nome editado.' : '' "
        />
        <div class="columns">
          <div class="column is-12 pb-0">
            <label :class="{ labelObrigatorio: isSelectTarefasInvalido }"
              >Adicionar tarefa <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="loading.campoTarefas"></span>
            </label>
            <TrfCardInfo
              mensagem="Tarefas inativas e parceladas não podem ser adicionadas ao grupo."
            />
            <Multiselect
              mode="multiple"
              :options="listaTarefas"
              v-model="grupoDeTarefas.tarefasId"
              class="multiselect-econtador"
              placeholder="Selecione uma ou mais tarefas"
              :closeOnSelect="false"
              :searchable="true"
              :canClear="false"
              noResultsText="Tarefa(s) não encontrada(s)."
              id="select-add-tarefa-grupo"
              ref="multiselect"
              :class="{ inValida: isSelectTarefasInvalido }"
              :disabled="loading.campoTarefas"
              @select="_selecionarTarefa"
              @deselect="_removerTarefa"
            >
              <template v-slot:multiplelabel="{ values }">
                <div class="multiselect-multiple-label">
                  {{ values.length }} tarefas selecionadas
                </div>
              </template>
            </Multiselect>
            <div class="mensagemDeErro">
              <span v-if="isSelectTarefasInvalido" class="campo-obrigatório"
                >Vincule tarefas em seu grupo.</span
              >
            </div>
          </div>
        </div>
        <div class="btn-container">
          <TrfButton
            nome="Adicionar todas"
            :temIcon="true"
            classIcon="mdi-plus-thick"
            classCor="is-light"
            id="btn-add-todas-tarefas-grupo"
            width="115px"
            height="22px"
            fontSize="12px"
            type="button"
            :disabled="loading.campoTarefas"
            @click.prevent="_selecionarTodasAsTarefas"
          />

          <TrfButton
            nome="Remover todas"
            :temIcon="true"
            classIcon="mdi-minus-thick"
            classCor="is-light"
            id="btn-remover-todas-tarefas-grupo"
            width="115px"
            height="22px"
            fontSize="12px"
            type="button"
            :disabled="loading.campoTarefas"
            @click.prevent="_removerTodasAsTarefas"
          />
        </div>
        <TrfTable
          v-if="this.dataSource.itens.length"
          :dataConfig="this.dataSource"
          :data="this.dataSource.itens"
          :isButtonMoreHidden="true"
          :showDropdownOptions="false"
          :showButtonsDefault="true"
          dataStatus=""
          :isScrollable="true"
          :showEdit="false"
          :shouldIgnorePreDelete="true"
          :disableExcluirButton="loading.btnExcluir"
        >
        </TrfTable>
      </div>

      <div v-show="!isGrupoPadraoProps && tabSelecionada == 'vinculo-empresas'">
          <div class="columns">
            <div class="column is-12 pb-0">
              <label>Empresas
                <span
                  class="button is-loading is-white pl-2 pr-2 is-inline-block"
                  style="height: 1.25em"
                  v-if="loading.campoEmpresas"
                ></span
              ></label>
              <Multiselect
                mode="multiple"
                :options="listaEmpresas"
                v-model="empresasIds.selecionadas"
                class="multiselect-econtador"
                :placeholder="placeholderEmpresa"
                :closeOnSelect="false"
                :searchable="true"
                :canClear="false"
                noResultsText="Empresa(s) não encontrada(s)."
                id="select-add-empresa-nova-tarefa"
                ref="multiselectEmpresa"
                :class="{
                  inValida: isSelectEmpresasInvalido,
                  'trf-is-placeholder-customizado': hasCustomEmpresaPlaceholder,
                }"
                @select="_selecionarEmpresa"
                @deselect="_removerEmpresa"
                :disabled="loading.campoEmpresas"
              >
                <template v-slot:multiplelabel="{}">
                  <div class="multiselect-multiple-label">
                    {{ dataSourceEmpresas.itens.length }} empresas selecionadas
                  </div>
                </template>
              </Multiselect>
              <div class="mensagemDeErro">
                <span v-if="isSelectEmpresasInvalido" class="campo-obrigatório"
                  >Vincule empresas ao grupo.</span
                >
              </div>
            </div>
          </div>
          <div class="btn-container">
            <TrfButton
              nome="Adicionar todas"
              :temIcon="true"
              classIcon="mdi-plus-thick"
              classCor="is-light"
              id="btn-add-todas-empresas"
              width="115px"
              height="22px"
              fontSize="12px"
              type="button"
              :disabled="loading.campoEmpresas"
              @click.prevent="_selecionarTodasAsEmpresas"
            />

            <TrfButton
              nome="Remover todas"
              :temIcon="true"
              classIcon="mdi-minus-thick"
              classCor="is-light"
              id="btn-remover-todas-empresas"
              width="115px"
              height="22px"
              fontSize="12px"
              type="button"
              :disabled="loading.campoEmpresas"
              @click.prevent="_removerTodasAsEmpresas"
            />
          </div>
          <div
            v-if="this.dataSourceEmpresas.itens.length"
            class="input-busca"
            style="
              width: calc(100% - 138px);
              float: right;
              margin-bottom: -48px;
              margin-right: 12px;
            "
          >
            <TrfInput
              placeholder="Pesquise pelo nome ou código da empresa"
              id="busca-empresa"
              :required="false"
              ref="inputBuscaTabela"
              v-model="buscaEmpresaTabela"
            />
          </div>
          <TrfTable
            v-if="this.dataSourceEmpresas.itens.length"
            :dataConfig="this.dataSourceEmpresas"
            :data="this.dataSourceEmpresas.itens"
            :isButtonMoreHidden="true"
            :showDropdownOptions="false"
            :showButtonsDefault="true"
            dataStatus=""
            :isScrollable="true"
            :showEdit="false"
            :shouldIgnorePreDelete="true"
            :isSelectable="false"
            :busca="buscaEmpresaTabela"
            idTable="empresaCadastroTable"
            :disableExcluirButton="loading.btnExcluir"
          >
          </TrfTable>
        </div>
    </form>
  </TrfModal>
</template>

<script>
import TrfModal from "../Modal";
import TrfInput from "../Input";
import TrfButton from "../Button";
import TrfTable from "../Table";
import Multiselect from "@vueform/multiselect";
import GrupoDeTarefas from "../../views/GrupoDeTarefas/model/grupo-de-tarefas.js";
import { service } from "../../views/GrupoDeTarefas/service/grupo-de-tarefas-service.js";
import { toastUtils } from '../../util/toast.utils.js';
import { utils } from "../../util/utils.js";
import TrfCardInfo from "../CardInfo";
import { setTransitionHooks } from "vue";

export default {
  name: "TrfModalCadastroGrupo",
  components: {
    TrfModal,
    TrfInput,
    TrfButton,
    TrfTable,
    Multiselect,
    TrfCardInfo
  },
  props: {
    isModalActive: Boolean,
    isModalEdicao: {
      type: Boolean,
      required: false,
      default: false
    },
    titulo: {
      type: String,
      required: false,
      default: "",
    },
    listaTarefas: {
      type: Array,
      required: false,
    },
    listaEmpresas: {
      type: Array,
      required: false,
    },
    loadingProps: {
        modal: true,
        conteudo: false,
        campoTarefas: false,
        campoEmpresas: false
    },
    isGrupoPadraoProps: {
      type: Boolean,
      deafult: false
    },
    listaGruposDeTarefa: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      grupoDeTarefas: new GrupoDeTarefas(),
      grupoDeTarefasEmEdicao: null,
      
      tabSelecionada: '',
      buscaEmpresaTabela: '',

      empresasIds: {
        escondidas: [],
        selecionadas: []
      },
      loading: {
        modal: this.loadingProps.modal,
        conteudo: this.loadingProps.conteudo,
        campoTarefas: this.loadingProps.campoTarefas,
        campoEmpresas: this.loadingProps.campoEmpresas,
        btnExcluir: true,
        btnSalvar: false
      },
      dataSource: {
        columns: [
          {
            name: "nome",
            label: "Selecionadas",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: item => this.$refs.multiselect.deselect(item.id),
      },
      dataSourceEmpresas: {
        columns: [
          {
            name: "nome",
            label: "Selecionadas",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: item => this.$refs.multiselectEmpresa.deselect(item.id),
      },
      isPrimeiraValidacao: true
    };
  },
  watch: {
    listaTarefas(valorNovo, valorAntigo) {
      if (!valorNovo && !valorAntigo) {
        this.loading.campoTarefas = false;
        this.loading.btnExcluir = false;
        return;
      }

      if(!valorNovo) {
        this.loading.campoTarefas = true;
        return;
      }

      this.loading.campoTarefas = false;
      this.loading.btnExcluir = false;
    },
    listaEmpresas(valorNovo, valorAntigo) {
      if (!valorNovo && !valorAntigo) {
        this.loading.campoEmpresas = false;
        this.loading.btnExcluir = false;
        return;
      }

      if(!valorNovo) {
        this.loading.campoEmpresas = true;
        return;
      }
      
      this.verificarEdicaoEmAndamento();

      this.loading.btnExcluir = false;
      this.loading.btnSalvar = false
      this.loading.campoEmpresas = false;
    }
  },
  methods: {
    verificarEdicaoEmAndamento() {
      if(this.isModalEdicao && this.grupoDeTarefasEmEdicao != null) {
        this.preencherEmpresasSelecionadas(this.grupoDeTarefasEmEdicao.empresasIdToNome);
      }
    },
    async chamarCadastroGrupo() {
      if(this.isCamposVazios()){
        return;
      }

      if(this.verificarCampoNome()){
        toastUtils.defaultToast(`Grupo de tarefas ${this.grupoDeTarefas.nome} já existe.`,"is-danger", "center");
        return;
      }

      this.$emit('ativarModalVigencia',this.grupoDeTarefas);
    },
    verificarCampoNome() {
      if (this.isModalEdicao && this.grupoDeTarefasEmEdicao.nome.toLowerCase().replace(/\s/g, '') == this.grupoDeTarefas.nome.toLowerCase().replace(/\s/g, '')) {
        return false;
      }
      return this.listaGruposDeTarefa.some(grupo=> grupo.nome.toLowerCase().replace(/\s/g, '') == this.grupoDeTarefas.nome.toLowerCase().replace(/\s/g, ''));
    },
    inicializarCamposNaEdicao(item) {
      this.loading.conteudo = true;
      
      this.grupoDeTarefas.nome = item.nome;
      this.grupoDeTarefas.padrao = item.padrao;
      this.grupoDeTarefas.id = item.id;
      
      if(Array.isArray(item.tarefas)) {
        this.dataSource.itens = item.tarefas.map((tarefa) => {
          return { id: tarefa.id, nome: tarefa.nome };
        });
      }

      this.grupoDeTarefas.tarefasId = this._getIds(item.tarefas);
      this.grupoDeTarefasEmEdicao = { ...item, ...this.grupoDeTarefas };

      this.preencherEmpresasSelecionadas(item.empresasIdToNome);

      utils.ordenarDeFormaCrescente(this.dataSource.itens);
      utils.ordenarDeFormaCrescente(this.dataSourceEmpresas.itens);

      this.loading.conteudo = false;
    },
    preencherEmpresasSelecionadas(empresas) {
      if(!empresas || !this.listaEmpresas.length) {
        return;
      }

      const empresasJson = JSON.parse(empresas);
      const idsEmpresasValidas = this._getValues(this.listaEmpresas);
      
      for (const key in empresasJson) {
        const id = parseInt(key);
        
        if(!idsEmpresasValidas.includes(id)) {
          this.empresasIds.escondidas.push(id);
          continue;
        }
        
        const empresaObj = {
          id,
          nome: empresasJson[key]
        };
        
        this.dataSourceEmpresas.itens.push(empresaObj);
      }

      this.empresasIds.selecionadas = this._getIds(this.dataSourceEmpresas.itens);
      this.grupoDeTarefas.empresasIds = this.empresasIds.escondidas.concat(this.empresasIds.selecionadas);
      this.grupoDeTarefasEmEdicao.empresasIds = [ ...this.grupoDeTarefas.empresasIds ];
    },
    verificarSeHouveEdicao(inseriuTarefas,inseriuEmpresas,removeuEmpresas) {
      return (inseriuTarefas || inseriuEmpresas || removeuEmpresas)
    },
    isCamposVazios() {
      this.isPrimeiraValidacao = false;

      const isInputNomeVazio = this.$refs.inputNome.verificarSeInputEstaVazio();

      if(isInputNomeVazio || this.isSelectTarefasVazio || (this.isSelectEmpresasVazio && !this.isGrupoPadraoProps)) {
        if (this.isSelectTarefasVazio) {
          toastUtils.dangerToast("Campo obrigatório!");
          this.abrirTabCadastro();
        }

        if ((!this.isSelectTarefasVazio && !isInputNomeVazio) && this.isSelectEmpresasVazio) {
          this.abrirTabEmpresas();
        }

        return true;
      }

      return false;
    },
    recarregarPaginaEDesativarLoader() {
      setTimeout(() => {
        this.loading.btnSalvar = false;
        window.location.reload(true);
      }, 2000);
    },
    hasTarefaNova() {
      return this.grupoDeTarefas.tarefasId.some(id => !this.grupoDeTarefasEmEdicao.tarefasId.includes(id));
    },
    hasTarefaRemovida() {
      return this.grupoDeTarefasEmEdicao.tarefasId.some(id =>
        !this.grupoDeTarefas.tarefasId.includes(id)
      );
    },
    hasEmpresaNova() {
      return this.grupoDeTarefas.empresasIds.some(id => !this.grupoDeTarefasEmEdicao.empresasIds.includes(id));
    },
    hasEmpresaRemovida() {
      return this.grupoDeTarefasEmEdicao.empresasIds.some(id =>
        !this.grupoDeTarefas.empresasIds.includes(id)
      );
    },
    limparModal() {
      this.$refs.inputNome.limparValidacao();
      this.grupoDeTarefas = new GrupoDeTarefas();
      this.grupoDeTarefasEmEdicao = null;
      this._removerTodasAsTarefas();
      this._removerTodasAsEmpresas();
      this.empresasIds = {
        escondidas: [],
        selecionadas: []
      };
      this.isPrimeiraValidacao = true;
    },
    abrirTabCadastro() {
      this.tabSelecionada = "cadastro";
    },
    abrirTabEmpresas() {
      this.tabSelecionada = "vinculo-empresas";
    },
    async _editarGrupoDeTarefas() {
      try {
        if(this.isCamposVazios()){
          return;
        }
        if(this.verificarCampoNome()){
          toastUtils.defaultToast(`Grupo de tarefas ${this.grupoDeTarefas.nome} já existe.`,"is-danger", "center");
          return;
        }

        const inseriuTarefas = this.hasTarefaNova();
        const removeuTarefas = this.hasTarefaRemovida();
        const inseriuEmpresas = this.hasEmpresaNova();
        const removeuEmpresas = this.hasEmpresaRemovida();

        if (removeuTarefas) {
          this.$emit('ativaModalEdicaoTarefas',this.grupoDeTarefas,inseriuTarefas,removeuTarefas,inseriuEmpresas,removeuEmpresas);
        } else if (this.isGrupoPadraoProps && (inseriuTarefas || (inseriuTarefas && removeuTarefas))) {
          this.$emit('ativaModalInclusaoTarefas',this.grupoDeTarefas,inseriuTarefas,removeuTarefas);
        } else if (inseriuTarefas && (!inseriuEmpresas && !removeuEmpresas)) {
          this.$emit('ativarModalVigencia',this.grupoDeTarefas,inseriuTarefas);
        } else if (inseriuEmpresas || removeuEmpresas) {
          this.$emit('ativarModalVigencia',this.grupoDeTarefas,inseriuTarefas,inseriuEmpresas,removeuEmpresas);
        } else {
          this.grupoDeTarefas.empresasIds = Array.from(new Set(this.grupoDeTarefas.empresasIds));
          if (removeuTarefas){
            this.grupoDeTarefas.removeuTarefasNaEdicao = true;
            this.grupoDeTarefas.isVinculaEmpresasGrupoPadrao = false;
          }
          this.loading.btnSalvar = true;
          this.grupoDeTarefas.deveAlterarRecorrencias = true;
          this.grupoDeTarefas.edicaoDeTarefasDesativada = false;
          await service.editarGrupoDeTarefas(this.grupoDeTarefas);
          this.recarregarPaginaEDesativarLoader();
        }
      } catch(e) {
        if(e.message){
          toastUtils.defaultToast(e.message,"is-danger", "center");
          this.loading.btnSalvar = false;
          return;
        }
        toastUtils.dangerToast("Ocorreu um erro ao editar o grupo de tarefas. Favor tente novamente");
        this.loading.btnSalvar = false;
      }
    },
    _selecionarTarefa(id) {
      const tarefa = this.listaTarefas.find((x) => x.value === id);
      this.dataSource.itens.push({ id: tarefa.value, nome: tarefa.label });
      utils.ordenarDeFormaCrescente(this.dataSource.itens);
    },
    _selecionarTodasAsTarefas() {
      this.dataSource.itens = this.listaTarefas.map((tarefa) => {
        return { id: tarefa.value, nome: tarefa.label };
      });
      this.grupoDeTarefas.tarefasId = this._getIds(this.dataSource.itens);
    },
    _removerTarefa(id) {
      this.dataSource.itens = this.dataSource.itens.filter(t => t.id != id);
    },
    _removerTodasAsTarefas() {
      this.grupoDeTarefas.tarefasId = [];
      this.dataSource.itens = [];
    },
    _selecionarEmpresa(id) {
      const empresa = this.listaEmpresas.find(x => x.value === id);
      const empresaObj = this._getEmpresaObj(empresa);

      this.dataSourceEmpresas.itens.push(empresaObj);
      this.grupoDeTarefas.empresasIds.push(empresaObj.id);

      utils.ordenarDeFormaCrescente(this.dataSourceEmpresas.itens);
    },
    _selecionarTodasAsEmpresas() {
      this.dataSourceEmpresas.itens = this.listaEmpresas.map(this._getEmpresaObj);
      utils.ordenarDeFormaCrescente(this.dataSourceEmpresas.itens);
      const ids = this._getIds(this.dataSourceEmpresas.itens);
      this.grupoDeTarefas.empresasIds = ids.concat(this.empresasIds.escondidas);
      this.empresasIds.selecionadas = ids;
    },
    _removerEmpresa(id) {
      this.dataSourceEmpresas.itens = this.dataSourceEmpresas.itens.filter(e => e.id != id);
      this.grupoDeTarefas.empresasIds = this.grupoDeTarefas.empresasIds.filter(i => i != id);
    },
    _removerTodasAsEmpresas() {
      this.grupoDeTarefas.empresasIds = this.empresasIds.escondidas;
      this.dataSourceEmpresas.itens = [];
      this.empresasIds.selecionadas = [];
    },
    _getEmpresaObj(e) {
      return {
        id: e.value,
        nome: e.label,
        parcelamento: {
          empresaId: e.value,
          parcelaAtual: "1",
          parcelaFinal: "1",
          validacao: {
            atual: {
              isValid: true,
              msg: "",
              disabled: false,
            },
            final: {
              isValid: true,
              msg: "",
              disabled: false,
            }
          }
        }
      }
    },
    _toArray(array) {
      return array ? array : [];
    },
    _getIds(array) {
      return array ? array.map(a => a.id) : [];
    },
    _getValues(array) {
      return array.map(o => o.value);
    }
  },
  computed: {
    placeholderEmpresa() {
      if (this.dataSourceEmpresas.itens.length == 1) {
        return "1 empresa selecionada";
      }
      
      if (this.dataSourceEmpresas.itens.length > 1) {
        return `${this.dataSourceEmpresas.itens.length} empresas selecionadas`;
      }

      return "Selecione uma ou mais empresas";
    },
    hasCustomEmpresaPlaceholder() {
      return this.dataSourceEmpresas.itens.length > 0;
    },
    isSelectTarefasInvalido() {
      if(this.isPrimeiraValidacao) return false;
      return this.isSelectTarefasVazio;
    },
    isSelectEmpresasInvalido() {
      if(this.isPrimeiraValidacao) return false;
      return this.isSelectEmpresasVazio;
    },
    isSelectTarefasVazio() {
      return this.grupoDeTarefas.tarefasId == undefined || this.grupoDeTarefas.tarefasId.length < 1;
    },
    isSelectEmpresasVazio() {
      return this.dataSourceEmpresas.itens == undefined || this.dataSourceEmpresas.itens.length < 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.btn-container {
  display: flex;
  justify-content: flex-end;
}
#btn-add-todas-tarefas-grupo {
  margin-right: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  height: 15px;
  margin: 0 0 10px 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.label-grupo {
  font-size: 12px;
}

</style>
